import { LSKeys, LocalStorage } from '@core/localStorage';
import { ThemeMode, ThemeModeConstants } from '@helpers/theme.helper';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RootState } from '../store';

interface AppState {
  globalContentMounted: boolean;
  // farm?: Farm;
  // firestoreNSC?: FSNSC;
  // categories?: CategoryOLD[];
  activeRequests: string[];
}

const initialState: AppState = {
  globalContentMounted: false,

  // farm: undefined,
  // firestoreNSC: undefined,
  // categories: undefined,
  activeRequests: [],
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setGlobalContentMounted: (state, { payload }: PayloadAction<boolean>) => {
      if (state.globalContentMounted !== payload)
        state.globalContentMounted = payload;
    },

    pushNetworkRequestUUID: (
      state,
      { payload: uuid }: PayloadAction<string, string>
    ) => {
      state.activeRequests = [...state.activeRequests, uuid];
    },

    popNetworkRequestUUID: (
      state,
      { payload: uuid }: PayloadAction<string>
    ) => {
      state.activeRequests = state.activeRequests.filter(
        request => request !== uuid
      );
    },
    // setFarm: (state, { payload: farm }: PayloadAction<Farm | undefined>) => {
    //   state.farm = farm;
    // },
    // setFSNSC: (state, { payload }: PayloadAction<FSNSC | undefined>) => {
    //   state.firestoreNSC = payload;
    // },
    // setNSCCategories: (
    //   state,
    //   { payload }: PayloadAction<CategoryOLD[] | undefined>
    // ) => {
    //   state.categories = payload;
    // },
  },
});

export const {
  setGlobalContentMounted,
  pushNetworkRequestUUID,
  popNetworkRequestUUID,

  // setFarm,
  // setFSNSC,
  // setNSCCategories,
} = appSlice.actions;

// export const selectFarm = (state: RootState) => state.app.farm;
// export const selectFSNSC = (state: RootState) => state.app.firestoreNSC;
export const selectGlobalContentMounted = (state: RootState) =>
  state.app.globalContentMounted;

// export const selectNSCCategories = (state: RootState) => state.app.categories;
export const selectIsLoading = (state: RootState) =>
  state.app.activeRequests.length > 0;
export const selectActiveRequests = (state: RootState) =>
  state.app.activeRequests;

export default appSlice.reducer;
